<template>
  <div class="cuerpo d-flex justify-content-center align-items-center text-center">
    <div class="tarjeta">
      <div class="d-flex align-items-center">
        <form class="form-signin w-100" @submit.prevent="login()">
          <div :class="mensajeError" v-if="error.length > 0" role="alert">
            <button type="button" class="close" v-on:click="limpiar">
              <span aria-hidden="true">&times;</span>
            </button>
            {{error}}
          </div>

          <img class="img-fluid imagen-empresa text-center w-25 mb-3"
               src="../../../static/img/Logo_eTaxi.png" alt="">
          <h1 class="h3 mb-3 font-weight-normal">Iniciar Sesion</h1>
          <label for="correo" class="sr-only">Correo</label>
          <input type="email" id="correo" v-model="input.correo" class="form-control mb-4" placeholder="Correo" required
                 autofocus>
          <label for="contrasena" class="sr-only">Contraseña</label>
          <input type="password" id="contrasena" v-model="input.contrasena" class="form-control"
                 placeholder="Contraseña" required>

          <button class="btn btn-lg btn-primary btn-block">Ingresar</button>
          <p class="mt-1 mb-3 text-muted">&copy; 2018</p>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
  import authService from './auth.Service'

  export default {
    name: "login",
    data() {
      return {
        error: '',
        input: {
          correo: '',//"orlandosigut@gmail.com",//breitenberg.gertrude@example.net",
          contrasena:'',// "etaxidomi123"// "secret"
        }
      }
    },
    computed: {
      mensajeError() {
        console.log(this.error);
        if (this.error) {
          return 'alert alert-danger';
        }
      }
    },
    created() {
      if (authService.isLogueado())
        this.$router.replace({name: "panel"});
    },
    methods: {
      login() {
        let self = this;
        authService.login(this.input)
          .then(response => {
            let partes_token = response.data.success.token.split('.');
            localStorage.setItem('tok_header1', partes_token[0]);
            localStorage.setItem('tok_header2', partes_token[1]);
            localStorage.setItem('toke_id', partes_token[2]);
            this.$router.replace({name: "panel"});
          }).catch(e => {
          if (e.response.data.error == "No autorizado") {
            self.error = 'Usuario o contraseña incorrecto';
          }
        });
      },
      limpiar: function () {
        this.error = '';
      }
    }
  }
</script>

<style scoped lang="scss">

  .cuerpo {
    height: 100vh;
    padding-top: 40px;
    padding-bottom: 40px;
    background-color: #fff;
  }

  .tarjeta {
    width: 22%;
    height: 60%;
  }

  /* Extra small devices (phones, 600px and down) */
  @media only screen and (max-width: 576px) {
    .tarjeta {
      width: 50%;
      height: 60%;
    }
  }

  /* Small devices (portrait tablets and large phones, 600px and up) */
  @media only screen and (min-width: 577px) {
    .tarjeta {
      width: 50%;
      height: 60%;
    }
  }

  /* Medium devices (landscape tablets, 768px and up) */
  @media only screen and (min-width: 768px) {
    .tarjeta {
      width: 40%;
      height: 60%;
    }
  }

  /* Large devices (laptops/desktops, 992px and up) */
  @media only screen and (min-width: 992px) {
    .tarjeta {
      width: 26%;
      height: 60%;
    }
  }

  /* Extra large devices (large laptops and desktops, 1200px and up) */
  @media only screen and (min-width: 1200px) {
    .tarjeta {
      width: 22%;
      height: 60%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/auth/login.vue